module.exports = __webpack_public_path__ + "img/testimonial-avatar.bc84fa40.svg";